import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { HelpModalPage } from './help-modal.page';
import { HelpItemTemplateComponent } from './help-item-template/help-item-template.component';

const routes: Routes = [
  {
    path: '',
    component: HelpModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [HelpModalPage,HelpItemTemplateComponent]
})
export class HelpModalPageModule {}
